import { Stack, Typography } from '@mui/material';

function TextLabelValue({
  id,
  defaultMessage,
  value,
  containerProps = {},
  ...props
}) {
  return (
    <Stack direction="column" {...containerProps}>
      <Typography variant="subtitle2" color="text.secondary" {...props}>
        {defaultMessage}
      </Typography>
      <Typography
        fontWeight="bold"
        variant="subtitle2"
        component="span"
        color="text.primary">
        {value}
      </Typography>
    </Stack>
  );
}

export default TextLabelValue;
